/* eslint import/no-cycle: 0 */
import styled from 'styled-components'
import { theme } from '../../../../styles/theme'
import { ContainerStyleProps } from './props'

export const Container = styled.div<ContainerStyleProps>`
  width: 100%;
  height: ${({ isOpen, itemAmount = 1 }) => (isOpen ? `${(itemAmount + 1) * 43 + 20}px` : '43px')};
  margin-bottom: 15px;
  
  background: ${theme.colors.lightBrown};
  border-radius: ${theme.border.normal};
  border: 1px solid transparent;

  overflow: hidden;

  transition: border-color 300ms;
  -webkit-transition: border-color 300ms;
  -moz-transition: border-color 300ms;
  -o-transition: border-color 300ms;
  transition: height, width 300ms ease;
  -webkit-transition: height 300ms ease;
  -moz-transition: height 300ms ease;
  -o-transition: height 300ms ease;
  transition: height 300ms ease;

  &:hover {
    border-color: #FFFFFF;
  }
`

export const Item = styled.div`
  width: 100%;
  height: 43px;
  padding: 12px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  border: none;
  background: ${theme.colors.lightBrown};
  overflow: hidden;
  cursor: pointer;

  position: relative;
`

export const ToggleButton = styled.button`
  background: none;

  position: absolute;
  right: 12px;
`

export const IconWrapper = styled.div`
  width: 18px;
  height: 43px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const ItemName = styled.p<ContainerStyleProps>`
  margin-left: 13px;

  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 600ms;

  color: ${theme.colors.white};
  font-size: ${theme.font.sizes.normal};
  line-height: ${theme.font.sizes.medium};

  &:hover {
    filter: brightness(0.8);
  }
`

export const Submenu = styled.div`
  padding-left: 18px;
  
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
